import CenteredLoadingAnimation from '../../../../core/CenteredLoadingAnimation'
import { Flex } from '../../../../core/Flex'

export const Loader = () => (
  <Flex
    css={{
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '500px',
      maxHeight: '100%'
    }}
  >
    <CenteredLoadingAnimation />
  </Flex>
)
